// utils/redirectUtils.js
export const RedirectUtils = {
  storeReturnUrl: (url) => {
    localStorage.setItem('returnUrl', url)
  },
  
  getReturnUrl: () => {
    return localStorage.getItem('returnUrl')
  },
  
  clearReturnUrl: () => {
    localStorage.removeItem('returnUrl')
  },
  
  redirectToStoredUrl: (navigate, defaultUrl = '/') => {
    const returnUrl = RedirectUtils.getReturnUrl()

    console.log(returnUrl); 
    
    if (returnUrl) {
      RedirectUtils.clearReturnUrl()
      navigate(returnUrl)
      return true
    }
    navigate(defaultUrl)
    return false
  }
}